import moment from "moment-jalaali";
import { convertDigitToEnglish } from "../convertDigitToEnglish";

let digit = (data) => {
  let value = data.toString();
  let length = value.length;

  if (length === 1) {
    return "0" + data;
  }
  return data;
};

export const data_m = () => {
  var d = new Date(),
    dformat =
      [d.getFullYear(), d.getMonth() + 1, d.getDate()].join("/") +
      " " +
      [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");

  let arr = dformat.split(" ");
  let date = arr[0].split("/");
  let time = arr[1].split(":");

  if (date.length !== 3 || time.length !== 3) {
    return false;
  }

  let fulldate = `${date[0]}/${digit(date[1])}/${digit(date[2])} ${
    digit(time[0]) + ":" + digit(time[1]) + ":" + digit(time[2])
  }.000000`;

  return fulldate;
};

export const dateMiladi = (value) => {
  if (!value) return;

  let dformat = moment(value, "jYYYY/jM/jD HH:mm").format("YYYY/MM/DD");

  return convertDigitToEnglish(dformat);
};

export const timeCurrent = () => {
  let d = new Date();

  return `${digit(d.getHours())}:${digit(d.getMinutes())}:${
    digit(d.getSeconds()) + ".000000"
  }`;
};

export const dateMiladiToShamsi = (value) => {
  if (!value) return;

  let dformat = moment(value, "YYYY/M/D HH:mm").format("jYYYY/jMM/jDD");

  return convertDigitToEnglish(dformat);
};

export const dateMiladiToShamsiAndWeekday = (value) => {
  if (!value) return;

  let dformat = moment(value, "YYYY/M/D HH:mm").format("jYYYY/jMM/jDD");
  // let weekday = moment(value, 'YYYY/M/D HH:mm').format('dddd')
  let weekdayNumber = moment(value, "YYYY/M/D HH:mm").format("d");

  return { shamsiDate: convertDigitToEnglish(dformat), weekday: weekdayNumber };
};

export const dateConverttShamsiToMiladi = (value) => {
  if (!value) return;

  let dformat = moment(value, "jYYYY/jM/jD HH:mm").format("YYYY/MM/DD");

  return convertDigitToEnglish(dformat);
};

export const convertDateShamsi = (state, array) => {
  let obj = {};
  let res = {};

  Object.keys(state).forEach((item) => {
    array.forEach((name) => {
      if (item === name) {
        if (name.includes("to_")) {
          obj[name] = `${convertDigitToEnglish(
            state[name].format("YYYY/MM/DD")
          )} 23:59:59.000000`;
        } else {
          obj[name] = `${convertDigitToEnglish(
            state[name].format("YYYY/MM/DD")
          )} 00:00:00.000000`;
        }
      } else {
        if (!obj[item]) obj[item] = state[item];
      }
    });
  });

  Object.keys(obj).forEach((element) => {
    if (obj[element]) {
      res[element] = obj[element];
    }
  });

  return res;
};

export function getLastDateShamsi(key = "week", format) {
  let obj = {
    day: -1,
    week: 6,
    ten: 10,
    month: 29,
    threemonth: 89,
    sixmonth: 179,
    year: 364,
  };

  const now = new Date();
  let value = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate() - obj[key]
  );
  let date = format
    ? dateMiladiToShamsi(value.toISOString().split("T")[0])
    : value.toISOString().split("T")[0].replaceAll("-", "/");

  return date;
}

export const getNameDays = (date) => {
  var dt = moment(date, "YYYY-MM-DD HH:mm:ss");
  return dt.format("dddd");
};

export const dateConvertMiladiToShamsi = (value) => {
  if (!value) return;

  let dformat = moment(value, "YYYY/M/D HH:mm").format("jYYYY/jMM/jDD");

  return convertDigitToEnglish(dformat);
};

export const dformatDate = (value) => {
  const startDate = value;
  const year = startDate.substring(0, 4);
  const month = startDate.substring(4, 6);
  const day = startDate.substring(6, 8);
  let displayDate = year + "/" + month + "/" + day;
  return displayDate;
};

export const justDateMiladi = () => {
  var d = new Date(),
    dformat =
      [d.getFullYear(), d.getMonth() + 1, d.getDate()].join("/") +
      " " +
      [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");

  let arr = dformat.split(" ");
  let date = arr[0].split("/");
  let time = arr[1].split(":");

  if (date.length !== 3 || time.length !== 3) {
    return false;
  }

  let fulldate = `${date[0]}/${digit(date[1])}/${digit(date[2])}`;

  return fulldate;
};
